module.exports = __webpack_public_path__ + "static/media/ma.a2e6a76e.svg";